import React, { useEffect } from 'react';
import * as serviceWorkerRegistration from '../serviceWorkerRegistration';

const ServiceWorkerUpdate: React.FC = () => {
  useEffect(() => {
    // Register the service worker with automatic update
    serviceWorkerRegistration.register({
      onUpdate: (registration) => {
        console.log('Service worker update detected');

        // Force update without user interaction
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
      },
    });

    // Restore scroll position after a service worker update
    const restorePosition = () => {
      const savedPosition = localStorage.getItem('sw_scroll_position');
      if (savedPosition) {
        window.scrollTo(0, parseInt(savedPosition, 10));
        localStorage.removeItem('sw_scroll_position');
      }
    };

    // Run after all content is loaded
    if (document.readyState === 'complete') {
      restorePosition();
    } else {
      window.addEventListener('load', restorePosition);
      return () => window.removeEventListener('load', restorePosition);
    }
  }, []);

  // No UI needed as updates are handled automatically
  return null;
};

export default ServiceWorkerUpdate;
